import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration
import Filter from 'jet-views/reports/referralsReport/filterReferralsReports'; // Importing the filter component for referrals report
import Table from 'jet-views/reports/referralsReport/tableReferralsReports'; // Importing the table component for referrals report

/**
 * ReferralsReportView class extends JetView to create a specific view for referrals report.
 */
export default class ReferralsReportView extends JetView {
    /**
     * Configures the layout of the referrals report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration for pagination and export options
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            hidden: true, // Initially hidden
            cols: [
                {
                    view: 'select',
                    options: ['10', '20', '50', '100'], // Options for number of items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            // Update pager size and refresh datatable on change
                            $$('datatableDetails').getPager().config.size = this.getValue() * 1;
                            $$('datatableDetails').refresh();
                            $$('datatableDetails').scrollTo(100, 0);
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export options
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            var size = $$('datatableDetails').getPager().config.size; // Get current page size
                            var page = $$('datatableDetails').getPage(); // Get current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index

                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatableDetails');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    filter: function (obj) {
                                        // Filter data for export based on pagination
                                        return (
                                            $$('datatableDetails').getIndexById(obj.id) >= first &&
                                            $$('datatableDetails').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Sesiones',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Sesiones',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatableDetails'), {
                                        filter: function (obj) {
                                            // Filter data for export based on pagination
                                            return (
                                                $$('datatableDetails').getIndexById(obj.id) >= first &&
                                                $$('datatableDetails').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        // Second toolbar configuration for total data
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select',
                    options: ['10', '20', '50', '100'], // Options for number of items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            // Update pager size and refresh datatable on change
                            $$('datatableTotal').getPager().config.size = this.getValue() * 1;
                            $$('datatableTotal').refresh();
                            $$('datatableTotal').scrollTo(100, 0);
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerB',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export options
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            var size = $$('datatableTotal').getPager().config.size; // Get current page size
                            var page = $$('datatableTotal').getPage(); // Get current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index

                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatableTotal');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) + 'Sesiones',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    filter: function (obj) {
                                        // Filter data for export based on pagination
                                        return (
                                            $$('datatableTotal').getIndexById(obj.id) >= first &&
                                            $$('datatableTotal').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Sesiones',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Sesiones',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatableTotal'), {
                                        filter: function (obj) {
                                            // Filter data for export based on pagination
                                            return (
                                                $$('datatableTotal').getIndexById(obj.id) >= first &&
                                                $$('datatableTotal').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        // Left side layout configuration
        const left = {
            height: 820,
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Reporte Referidos') }, // Title label for the report
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include the filter component
                Table, // Include the table component
                toolbar, // Include the first toolbar
                toolbar2, // Include the second toolbar
            ],
        };

        // Return the main configuration object for the view
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scrollY: true,
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Include the left layout
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Check screen size for responsive adjustments
            if (screen.width < 500 || screen.height < 500) {
                var childs = $$('toolbar').getChildViews(); // Get child views of the first toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export option from the first toolbar
                $$('pagerA').define('group', 1); // Define pager grouping
                var childs2 = $$('toolbar2').getChildViews(); // Get child views of the second toolbar
                $$('toolbar2').removeView(childs2[2]); // Remove the export option from the second toolbar
                $$('pagerB').define('group', 1); // Define pager grouping
            }
        });
    }
}

// FILE DOCUMENTED
